import NetworkService from "./NetworkService";
import { config } from "../config/ResoureConfig";

const ResourceConfig = config;

const ConfigServiceInstance = (() => {
  let instance;

  function createInstance() {
    return new ConfigService();
  }

  return {
    getInstance: function () {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    },
  };
})();

export default ConfigServiceInstance;

/**
 * Per-environment client config (context path, relying-party URL, …).
 *
 * Resolution order:
 *   1. `window.__ACCOUNT_AUTH_CONFIG` — written into the served shell by the Thymeleaf
 *      template, so the values are available synchronously before any
 *      component renders. Absent under the Vite dev server.
 *   2. `/config/config.json` — fetched lazily by `load()`. Only the few
 *      readers that depend on environment-specific values (the redirect
 *      stub, the sign-up "sign in" link) wait on it; nothing blocks first
 *      paint on this request any more.
 *   3. `ResoureConfig.js` defaults — baked into the bundle.
 */
class ConfigService {
  _data = {};
  _loading = null;

  constructor() {
    const inline =
      typeof window !== "undefined" && window.__ACCOUNT_AUTH_CONFIG
        ? window.__ACCOUNT_AUTH_CONFIG
        : null;
    this._data = Object.assign({}, ResourceConfig, inline);
    this._inlined = !!inline;
  }

  /**
   * Resolves with this service once environment config is known. Memoised:
   * the network request is issued at most once per page load, and never when
   * the template already inlined the values.
   */
  load = () => {
    if (this._loading) return this._loading;
    if (this._inlined) {
      this._loading = Promise.resolve(this);
      return this._loading;
    }

    const endpoint = `${
      (this._data && this._data.context) || "account-auth"
    }/config/config.json`;
    this._loading = NetworkService.get(endpoint)
      .then((response) => {
        this._data = Object.assign({}, ResourceConfig, response);
        return this;
      })
      .catch((error) => {
        console.log(error);
        return this;
      });
    return this._loading;
  };

  get = () => {
    return this._data;
  };

  formulateContextPath = (path) => {
    return `${this._data.context}${path}`;
  };

  getContextPath = (path) => {
    return path.replace(this._data.context, "");
  };

  getUserLocation = async () => {
    try {
      // If you don't pass an IP, it uses the requester's IP automatically
      const response = await fetch('https://global.ketchcdn.com/web/v3/ip');

      return await response.json();
    } catch (error) {
      console.error("Error fetching geolocation:", error);
    }
    return {};
  }

}
